<form (ngSubmit)="submit()" novalidate [formGroup]="form">
  <ion-list>
    <ion-item>
      <ion-label class="lbl-wrap Textresized">
        {{ 'CreditCard.Agreements.Agree' | translate }}
        <a (click)="showTerms()">{{ 'CreditCard.Agreements.Terms' | translate }}</a>
        {{ 'CreditCard.Agreements.And' | translate }}
        <a (click)="showPolicies()">{{ 'CreditCard.Agreements.Policies' | translate }}</a>
        {{ 'CreditCard.Agreements.End' | translate }}
        {{ merchantName | uppercase }}{{ 'CreditCard.Agreements.BYSHOPACHAT' | translate }}<span style="color:red;">*</span>
      </ion-label>
      <ion-checkbox (ionChange)="submit()" formControlName="terms" color="primary" slot="start"></ion-checkbox>
      @if (formErrors.has('terms')) {
        <span color="danger"><br />{{formErrors.get('terms')}}</span>
      }
    </ion-item>
  </ion-list>
</form>